<!-- body wrapper  -->
<div class="body-wrapper">
    <!-- ===========banner section===========  -->
    <section>
        <!-- banner  -->
        <div class="banner">
            <!-- banner slider  -->
            <div class="swiper bannerSlider">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let slide of sliderArr; let i = index;">
                        <div class="banner-item">
                            <img [src]="slide?.image" alt="prism-website-image" class="banner-img">
                            <div class="banner-content">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12">
                                            <div class="content">
                                                <p class="sm-title">{{slide?.subTitle}}</p>
                                                <h1 class="title">{{slide?.mainTitle}}</h1>
                                                <p class="banner-des">{{slide?.description}}</p>
                                                <div class="banner-btn-div">
                                                    <a [routerLink]="slide?.btn1Link"
                                                        class="custom-btn">{{slide?.btn1Text}}</a>

                                                    <a (click)="videoOverlay.openVideo(slide?.btn2Link)"
                                                        class="play-video cursor-pointer">
                                                        <span class="icofont-ui-play play-icon"></span>
                                                        {{slide?.btn2Text}}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="slider-nav">
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
            <!-- banner slider end  -->
        </div>
        <!-- banner end  -->
    </section>
    <!-- ==============banner section end =========== -->

    <!-- ===============about section ============ -->
    <section>
        <!-- about  -->
        <div class="about cpy-8 ">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="col-lg-6 pb-4">
                        <div class="about-img">
                            <img src="assets/img/about/2.png" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="about-content">
                            <div class="sec-head mb-3">
                                <h4>About us</h4>
                                <h2 class="inside-head">Textile Machinery Producer in India</h2>
                            </div>

                            <div class="about-content-inner mb-2">
                                <p>
                                    We introduce ourselves as one of the most leading and emerging textile machines
                                    manufacturing unit as <span class="theme-color fw-bold">Prism Textile
                                        Machinery</span>, established in July 2010. One Stop
                                    Solution for weaving preparatory and denim manufacturing all machines including both
                                    technologies Rope Dyeing & Slasher Dyeing except looms.
                                </p>
                                <p>
                                    We are manufacturing latest technological machines - High Speed Direct Warping
                                    Machine, PLC based Multi Cylinder Sizing Machine, Indigo Dyeing with Slasher and
                                    Rope Technology, etc. with good engineering practice and international quality
                                    standards - backed with satisfactory after sales and services. In last few years of
                                    our existence, we have carved a niche par excellence in the market through
                                    consistently providing world class products and services. We have been striving to
                                    offer our customers, hi-tech machineries and latest equipment that assist to enhance
                                    the production and quality, thereby reducing the input cost of our valued clients.
                                </p>
                            </div>
                            <div class="signature">
                                <a routerLink="/about-us" class="custom-btn">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end  -->
            </div>
            <!-- container  -->
        </div>
        <!-- about end  -->
    </section>
    <!-- ============about section end ========= -->

    <!-- ===================check out process========= -->
    <section>
        <div class="process project cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-12 col-md-12 col-sm-12 mb-5">
                            <div class="sec-head">
                                <h2>Customer <span>Satisfaction</span> Is Our Commitment</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end  -->
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-sm-6 mb-4" *ngFor="let sat of satisfactionArr;">
                        <div class="check-out-card">
                            <div class="check-out-icon">
                                <img [src]="sat?.image" alt="">
                            </div>
                            <div class="check-out-details">
                                <h5>{{sat?.title}} <span class="theme-color fw-bolder">{{sat?.mainTitle}}</span></h5>
                                <p>{{sat?.description}}</p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </section>

    <!-- ==========service section ========= -->
    <section>
        <!-- service  -->
        <div class="services cpy-8">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-7 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4>our service areas</h4>
                                <h2 class="my-3">our product categories</h2>
                                <p>Our company offers <span class="theme-color fw-bold">Cotton
                                        Machines</span> for ginning, spinning, and weaving cotton fabric, and <span
                                        class="theme-color fw-bold">Technical Machines</span> for advanced denim fabric
                                    processing, including dyeing, finishing, and automation solutions for high-quality
                                    textile production.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end  -->
                <!-- service card  -->
                <div class="service-card-area mt-5">
                    <!-- row  -->
                    <div class="row justify-content-center">
                        <div class="col-md-4 col-lg-3 col-sm-6 mb-4">
                            <div class="service-card">
                                <div class="service-icon">
                                    <img src="assets/img/icon/9.png" alt="prism-website-image">
                                </div>
                                <div class="service-card-content">
                                    <h5 class="name theme-color fw-bolder">Cotton Machines</h5>
                                    <p>
                                        Textile cotton machinery processes raw cotton into yarn or fabric through
                                        ginning, spinning, weaving, and finishing.
                                    </p>
                                    <a [routerLink]="['/product', 'cotton']"
                                        class="more-btn fw-bolder text-decoration-underline">Read More</a>
                                    <div class="hov-effect">
                                        <img src="assets/img/icon/9.png" alt="prism-website-image">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 col-lg-3 col-sm-6 mb-4">
                            <div class="service-card">
                                <div class="service-icon">
                                    <img src="assets/img/icon/10.png" alt="prism-website-image">
                                </div>
                                <div class="service-card-content">
                                    <h5 class="name theme-color fw-bolder">Technical Machines</h5>
                                    <p>
                                        Textile technical machinery automates weaving, dyeing, and finishing processes
                                        for efficient denim fabric manufacturing.
                                    </p>
                                    <a [routerLink]="['/product', 'technical']"
                                        class="more-btn fw-bolder text-decoration-underline">Read More</a>
                                    <div class="hov-effect">
                                        <img src="assets/img/icon/10.png" alt="prism-website-image">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- row end  -->
                </div>
                <!-- service card end  -->
            </div>
            <!-- container end  -->
        </div>
        <!-- service end  -->
    </section>
    <!-- ==========service section end ========= -->
    <!-- ================video section ============= -->
    <div class="work-history">
        <div class="container">
            <div class="history-bg">
                <div class="row justify-content-center">
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/18.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>43+</h2>
                                    <p>Years Of Experience</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/19.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>900+ </h2>
                                    <p>Machines Installed</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/19.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>4 </h2>
                                    <p>Manufacturing Units</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/20.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>90%</h2>
                                    <p>Repeat Orders</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="video-sec">

        <img src="assets/img/video/1.png" alt="prism-website-image">

        <div class="video-play">
            <a (click)="videoOverlay.openVideo('www.youtube.com/embed/NUooTKtmgz8')"
                class="play-video video-btn cursor-pointer"><span class="icofont-ui-play play-icon-larg"></span></a>
        </div>
    </div>
    <!-- ================video section end ============= -->


    <!-- ===========customer review ======= -->
    <section>
        <!-- customer  -->
        <div class="customer cpy-8">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-7 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4>Satisfied Clients</h4>
                                <h2 class="my-3">Happy Customers Reviews</h2>
                                <p>Customer feedback fuels our innovation, builds our trust, and drives our excellence.
                                    Real
                                    reviews from real customers—because your satisfaction is our top priority, always!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--row end  -->
                <!-- mt-5  -->
                <div class="mt-5">
                    <div class="swiper customerSlider">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide pb-4" *ngFor="let review of reviewArr;">
                                <div class="customer-card bg-white">
                                    <div class="customer-info">
                                        <div class="customer-img">
                                            <img [src]="review?.image" alt="prism-website-image">
                                        </div>
                                        <div class="customer-p-info mb-0">
                                            <h5>{{review?.name}}</h5>
                                        </div>
                                    </div>
                                    <div class="review">
                                        <p>{{review?.review}}</p>
                                        <div class="rating">
                                            <ul class="rating-ul">
                                                <li>
                                                    <i class="icofont-ui-rating"
                                                        [ngClass]="{'unrate': review?.rating < 1}"></i>
                                                </li>
                                                <li>
                                                    <i class="icofont-ui-rating"
                                                        [ngClass]="{'unrate': review?.rating < 2}"></i>
                                                </li>
                                                <li>
                                                    <i class="icofont-ui-rating"
                                                        [ngClass]="{'unrate': review?.rating < 3}"></i>
                                                </li>
                                                <li>
                                                    <i class="icofont-ui-rating"
                                                        [ngClass]="{'unrate': review?.rating < 4}"></i>
                                                </li>
                                                <li>
                                                    <i class="icofont-ui-rating"
                                                        [ngClass]="{'unrate': review?.rating < 5}"></i>
                                                </li>
                                            </ul>
                                            <p class="rating-count">{{review?.rating | number: '1.1-1'}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="signature text-center">
                        <a routerLink="/testimonial" class="custom-btn">
                            Know More
                        </a>
                    </div>
                </div>
                <!-- mt-5 end  -->
            </div>
            <!-- container end  -->
        </div>
        <!-- customer end  -->
    </section>
    <!-- ===========customer review end  ======= -->
    <!-- =============latest blog post========== -->
    <section>
        <div class="latest-blog cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-7 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4>Our Loyal Clients</h4>
                                <h2 class="my-3">pillars of our business</h2>
                                <p>Empowering our clients with textile machinery, ensuring efficiency, quality, and
                                    innovation for a sustainable and successful future.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--row end  -->
                <!-- mt-5  -->
                <div class="mt-5">
                    <div class="swiper our-client">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide mb-0" *ngFor="let client of ourClientsArr;">
                                <div class="client-image-sec">
                                    <img [src]="client?.image" class="img-fluid img-thumbnail bg-theme">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- mt-5 end  -->
                <div class="mt-5 text-center">
                    <a routerLink="/clients" class="custom-btn">View More</a>
                </div>
            </div>
        </div>
    </section>
    <!-- =============latest blog post end ========== -->

    <app-video-overlay #videoOverlay></app-video-overlay>

</div>
<!-- body wrapper end -->